import { ClientLogger } from 'bernie-client';

/* eslint-disable max-lines */

import { STORE_EVENTS } from 'stores/events/store-events';

import { LodgingPwaPropertySearch } from '__generated__/api';

const logger = ClientLogger.getLoggerWithIdentifier('pwa.adapter.bex-api.search-results');

export const mapOmnitureData = (analytics: any): any | null => {
  if (Array.isArray(analytics) && analytics.length > 0 && analytics[0]) {
    return analytics[0];
  }
  logger.logEvent(STORE_EVENTS.BEX_API_SEARCH_RESULTS_OMNITURE_PARSE_ERROR, 'Failed to parse omniture data');

  return null;
};

export const mapSearchedDestination = (query: LodgingPwaPropertySearch.query): string | undefined =>
  query.propertySearch.criteria.primary.destination.regionName ?? undefined;
